// 人物美颜
const jyRoutes = Array.from({ length: 28 }, (_, i) => ({
  path: `beautiful/jy/index${i + 1}`,
  name: `beautiful/jy/Index${i + 1}`,
  component: () => import(`@/views/edit/beautiful/jy/index${i + 1}.vue`)
}))
const xtRoutes = Array.from({ length: 30 }, (_, i) => ({
  path: `beautiful/xt/index${i + 1}`,
  name: `beautiful/xt/Index${i + 1}`,
  component: () => import(`@/views/edit/beautiful/xt/index${i + 1}.vue`)
}))


import beautifulIndex from '@/views/edit/beautiful/index'



export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'beautiful/index',
      name: 'beautifulIndex',
      component: beautifulIndex
    },
    // 人物美颜，开始
    ...jyRoutes,
    ...xtRoutes,
    // 人物美颜，结束


  ],
};
